/**
 * 成绩分享工具
 *
 * 生成"一次考试成绩"的分享链接：
 * 成绩单数据不再塞进 URL（避免长 token），而是由后端 ScoreShareController
 * 存库并生成短 token，链接只携带 token。家长扫码后由 score-share 页按 token 取数。
 *
 * 链接形式：<frontendBaseUrl>#/share/score/<token>
 */

import { environment } from "../../../environments/environment";

export interface ShareScoreSubject {
  subject: string;
  score: number;
}

export interface ShareScorePayload {
  /** 数据版本，当前为 1 */
  v: number;
  studentName: string;
  grade?: string;
  className?: string;
  examName: string;
  examDate: string;
  stage?: string;
  subjects: ShareScoreSubject[];
  totalScore: number;
  /** 生成时间戳（毫秒），可选 */
  genTime?: number;
}

/** 用短 token 构造完整分享链接（配合 hash 路由） */
export function buildScoreShareUrl(token: string): string {
  return `${environment.frontendBaseUrl}/#/share/score/${token}`;
}
